import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  Vendor,
  VendorDashboardCounts,
  VendorListItem,
  VendorListParams,
  VendorPayload,
  VendorPartnerListParams,
  VendorStatus,
  VendorStatusPayload,
} from '../models/vendor-management-row';
import { PartnerListItem } from '../../partner-management/models/partner-management';

export const VendorManagementActions = createActionGroup({
  source: 'Vendor Management',
  events: {
    'Load List': props<{ params: VendorListParams }>(),
    'Load List Success': props<{
      rows: VendorListItem[];
      total: number;
      page: number;
      pageSize: number;
      counts: VendorDashboardCounts;
    }>(),
    'Load List Failure': props<{ error: string }>(),
    'Load Vendor': props<{ vendorId: string }>(),
    'Load Vendor Success': props<{ vendor: Vendor }>(),
    'Load Vendor Failure': props<{ error: string }>(),
    'Load Vendor Partners': props<{
      vendorId: string;
      params: VendorPartnerListParams;
    }>(),
    'Load Vendor Partners Success': props<{
      rows: PartnerListItem[];
      total: number;
      page: number;
      pageSize: number;
    }>(),
    'Load Vendor Partners Failure': props<{ error: string }>(),
    'Create Vendor': props<{ payload: VendorPayload }>(),
    'Update Vendor': props<{ vendorId: string; payload: VendorPayload }>(),
    'Persist Success': props<{ message: string; vendor: Vendor }>(),
    'Persist Failure': props<{ error: string }>(),
    'Update Vendor Status': props<{
      vendorId: string;
      status: VendorStatus | VendorStatusPayload;
    }>(),
    'Update Vendor Status Success': props<{
      message: string;
      vendor: Vendor;
    }>(),
    'Update Vendor Status Failure': props<{ error: string }>(),
    'Clear Error': emptyProps(),
    'Clear Success Message': emptyProps(),
  },
});
